import React from "react";

import cx from "./cx";

const baseClass =
  "flex h-10 w-full border bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm";

type Props = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, Props>(
  ({ className, type, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cx(baseClass, className)}
      {...props}
      onWheel={(e) => e.currentTarget.blur()}
    />
  )
);

Input.displayName = "Input";

export { Input };
export default Input;
